import { render, staticRenderFns } from "./MembersMenu.vue?vue&type=template&id=c2c4ad6a&"
import script from "./MembersMenu.vue?vue&type=script&lang=ts&"
export * from "./MembersMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MembersMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports